import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

export const getWorkoutRequestsQuery = (trainerIds: string[]) => ({
  trainerIds: trainerIds,
  date: {
    range: {
      relative: {
        startDate: {
          value: 0
        }
      }
    }
  },
  statuses: [
    racehorse360.WorkoutRequestStatus.WORKOUT_REQUEST_STATUS_REQUESTED,
    racehorse360.WorkoutRequestStatus.WORKOUT_REQUEST_STATUS_EXAM_PENDING,
    racehorse360.WorkoutRequestStatus.WORKOUT_REQUEST_STATUS_APPROVED
  ]
});
